export default "__VITE_ASSET__BGabOZi7__"